module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAyCAMAAADC1sOAAAAANlBMVEUAAAAkLHQkLHYhKXolLXYlLXYlLHYgLXAjLHUlLXUlLXUlLHYjLXYkLHYkLHYjLXMlKnAlLXZLLTa3AAAAEXRSTlMAQIAf3++fEJBgv3BQz69QMNUICrYAAACZSURBVEjH7dbtCoIhDIbhTd181b52/icbbyWtH8EeiAjy/n+hoqL0obiLieY4SHavRUGzGQdFsVmPgWzPakiwE3mJJb4naks+dWJLvsMDDLFo5WaSITWibFBSaTOsQR0Uigt4VokYFJlIIbDtO64Y2DufjsUlfpNfUv7p077E34sL/DqT2KwA3xLwY9LdjUNGkUFAlRu/WfUV7P46ft/SWM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/spinner/icons/spinner-plus.png
// module id = 1128
// module chunks = 0